import { useState } from 'react';

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);

  const faqs = [
    {
      question: 'Что такое работа с возражениями?',
      answer: 'Работа с возражениями — это навык профессионального общения с клиентом, при котором менеджер не спорит и не давит, а помогает клиенту получить недостающую информацию, убедиться в ценности предложения и принять взвешенное решение. Это ключевой компонент успешных продаж и переговоров, который отличает профессионала от любителя.',
    },
    {
      question: 'Почему сотрудники начинают давать скидку при первом возражении?',
      answer: 'Сотрудники дают скидку, потому что не умеют продавать ценность и не знают, как отвечать на возражения уверенно. Отсутствие тренировки в реальных ситуациях приводит к страху потерять клиента, и менеджер идёт по пути наименьшего сопротивления — снижает цену вместо того, чтобы укрепить позицию через аргументацию и ценность.',
    },
    {
      question: 'Можно ли обучить опытных менеджеров работе с возражениями?',
      answer: 'Да, опытные менеджеры часто выигрывают от обучения больше новичков, потому что у них уже есть база практических ситуаций для разбора. Мы работаем с реальными кейсами каждого участника, выявляем скрытые привычки и заменяем неэффективные паттерны на рабочие стратегии.',
    },
    {
      question: 'Сколько длится тренинг по работе с возражениями?',
      answer: 'Интенсивный формат — 1–2 дня, модульное обучение — от 2 недель до 2 месяцев, комплексная программа с сопровождением — до 3–6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
    },
    {
      question: 'Можно ли использовать реальные звонки и переписки на тренинге?',
      answer: 'Да, и это обязательная часть программы. Мы прослушиваем реальные записи звонков, анализируем переписки, разбираем конкретные ситуации с реальными клиентами компании. Это повышает вовлечённость в десятки раз и позволяет сразу применить навыки в знакомых сценариях.',
    },
    {
      question: 'Проводится ли обучение онлайн?',
      answer: 'Да, тренинг по работе с возражениями доступен в онлайн-формате с использованием интерактивных инструментов, ролевых переговоров через видеосвязь, разбора реальных кейсов и записи сессий. Онлайн-формат не уступает очному по эффективности при правильной организации.',
    },
    {
      question: 'Можно ли совместить тренинг с обучением переговорам или продажам?',
      answer: 'Да, работа с возражениями — это неотъемлемая часть переговоров и продаж. Мы часто интегрируем модуль работы с возражениями в более широкие программы по продажам или переговорам. Такой подход позволяет обучить сотрудников комплексному циклу коммуникации с клиентом.',
    },
    {
      question: 'Какие результаты можно ожидать после обучения?',
      answer: 'Типичные результаты: рост конверсии на 18–55%, снижение процента скидок, увеличение среднего чека, рост продлений и повторных продаж, уверенность сотрудников в общении с трудными клиентами. Конкретные показатели зависят от исходного уровня команды и активности руководителя во внедрении.',
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые популярные вопросы о корпоративном обучении работе с возражениями.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  {openFaq === index ? (
                    <i className="ri-arrow-up-s-line text-teal-600"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-teal-600"></i>
                  )}
                </div>
              </button>
              <div className={`px-6 pb-6 ${openFaq === index ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}